export default "__VITE_ASSET__CsAb$dYL__"